import { NOT_APPROVED_EXPORT_BLOCKER } from './payroll-run-readiness';

export const PERIOD_TIMESHEET_NOT_APPROVED_CODE = 'TIMESHEET_NOT_APPROVED';

/** Grid row blockers (summarisePayrollRunReadiness) → period hub blocker codes. */
export const GRID_TO_PERIOD_READINESS_BLOCKER_CODE: Record<string, string> = {
  [NOT_APPROVED_EXPORT_BLOCKER]: PERIOD_TIMESHEET_NOT_APPROVED_CODE,
  'Award classification is missing.': 'WORKER_MISSING_PAY_PROFILE',
  'Award classification requires payroll review before export.': 'ASSIGNMENT_PAY_CONTEXT_BLOCKED',
  'Pay calculation is missing or zero.': 'TIMESHEET_ZERO_PAY',
};

export function mapGridBlockerToPeriodCode(blockerMessage: string): string | null {
  const trimmed = blockerMessage.trim();
  if (!trimmed) return null;
  if (GRID_TO_PERIOD_READINESS_BLOCKER_CODE[trimmed]) {
    return GRID_TO_PERIOD_READINESS_BLOCKER_CODE[trimmed];
  }
  if (trimmed.includes('open payroll dispute')) return 'TIMESHEET_PAY_CONTEXT_BLOCKED';
  if (trimmed.includes('Automatic payroll export is limited to')) return 'EBA_EXPORT_NOT_READY';
  if (trimmed.includes('10 ordinary hours without a recorded 10-hour agreement')) {
    return 'RATE_SCHEDULE_GAP';
  }
  return null;
}

export function buildPayrollReadinessHubHref(input: {
  rosterPeriodId?: string | null;
  periodStart?: string | null;
  periodEnd?: string | null;
  tab?: string;
}): string {
  const params = new URLSearchParams();
  if (input.rosterPeriodId) {
    params.set('period_id', input.rosterPeriodId);
  } else {
    if (input.periodStart) params.set('period_start', input.periodStart);
    if (input.periodEnd) params.set('period_end', input.periodEnd);
  }
  if (input.tab) params.set('tab', input.tab);
  const query = params.toString();
  return query.length > 0 ? `/payroll/readiness?${query}` : '/payroll/readiness';
}

export function resolveDominantRosterPeriodId(
  rows: Array<{ rosterPeriodId?: string | null; roster_period_id?: string | null }>,
): string | null {
  const counts = new Map<string, number>();
  for (const row of rows) {
    const id = row.rosterPeriodId ?? row.roster_period_id ?? null;
    if (!id) continue;
    counts.set(id, (counts.get(id) ?? 0) + 1);
  }
  let dominant: string | null = null;
  let max = 0;
  for (const [id, count] of counts) {
    if (count > max) {
      dominant = id;
      max = count;
    }
  }
  return dominant;
}
